import { render, staticRenderFns } from "./DarkModeSwitcher.vue?vue&type=template&id=ce3f9ac6"
import script from "./DarkModeSwitcher.vue?vue&type=script&lang=js"
export * from "./DarkModeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports